import {useCallback, useMemo} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

export interface ProcessEndedEventParams {
  endpoint: string;
  outcome_id?: string;
  original_id?: string;
  error?: string;
  process_details?: string;
  process_id: string;
  process_name: string;
  result: string;
}

export interface ProcessStartedEventParams {
  endpoint: string;
  asset_id?: string;
  original_id?: string;
  interaction_id: string;
  process_details?: string;
  process_id: string;
  process_name: string;
  source?: string;
}

function useProcessEvent() {
  const started = useCallback(
    ({
      endpoint,
      asset_id = '',
      original_id = '',
      interaction_id,
      process_details = '',
      process_id,
      process_name,
      source = '',
    }: ProcessStartedEventParams) => {
      AnalyticsService.dispatchEvent(
        eventNames.CONTENT_STUDIO_PROCESS_STARTED,
        {
          endpoint,
          asset_id,
          original_id,
          interaction_id,
          process_details,
          process_id,
          process_name,
          source,
        }
      );
    },
    []
  );

  const ended = useCallback(
    ({
      endpoint,
      outcome_id = '',
      original_id = '',
      error = '',
      process_details = '',
      process_id,
      process_name,
      result,
    }: ProcessEndedEventParams) => {
      AnalyticsService.dispatchEvent(eventNames.CONTENT_STUDIO_PROCESS_ENDED, {
        endpoint,
        outcome_id,
        original_id,
        error,
        process_details,
        process_id,
        process_name,
        result,
      });
    },
    []
  );

  return useMemo(() => ({started, ended}), [started, ended]);
}

export default useProcessEvent;
